import { Injectable, signal } from "@angular/core";
import { OrderApprovalRangeDto } from "src/app/features/pages/order/model/order-approval-range.model";
import { OrderApprovalRangeApi } from "../service/order-approval-range.api";
import { finalize } from "rxjs";

@Injectable({ providedIn: 'root' })
export class OrderApprovalRangeState {
    private readonly _selection = signal<OrderApprovalRangeDto | null>(null);
    private readonly _loading = signal<boolean>(true);

    readonly selection = this._selection.asReadonly();
    readonly loading = this._loading.asReadonly();

  constructor(    
    private _orderApprovalRangeApi: OrderApprovalRangeApi
) {

}

  load() {
    this._loading.set(true);

    this._orderApprovalRangeApi.load()
    .pipe(
            finalize(() => this._loading.set(false))
          )
    .subscribe({
      next: selection => {
        this._selection.set(selection);
        this._loading.set(false);
      },
      error: err => {
        this._loading.set(false);
      }
    });
  }

}